/**
 * horizontalCardContainer.tsx
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const HorizontalCardContainer = styled.div<
  React.CSSProperties & { focused?: boolean; hide?: boolean }
>`
  border: ${4 * Screen.widthRatio}px solid
    ${(props) => (props.focused ? 'white' : 'transparent')};
  border-radius: ${20 * Screen.widthRatio}px;
  cursor: pointer;
  float: left;
  height: ${197 * Screen.widthRatio}px;
  margin-right: ${2 * Screen.widthRatio}px;
  margin-bottom: ${2 * Screen.widthRatio}px;
  overflow: hidden;
  width: ${350 * Screen.widthRatio}px;
  display: ${(props) => (props.hide ? 'none' : 'block')};
  &:hover {
    border: ${4 * Screen.widthRatio}px solid white;
  }
`;

export default HorizontalCardContainer;
